module.exports = __webpack_public_path__ + "static/media/event.98212137.svg";